import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { CTLink } from 'components/common/CTLink';
import CloseIcon from '@material-ui/icons/Close';
import HamburgerIcon from 'assets/images/hamburger.svg';
import HomeIcon from 'assets/images/home.svg';
import OrdersIcon from 'assets/images/cart.svg';
import BarChartIcon from '@material-ui/icons/BarChart';
import qs from "query-string";
// import { excludedUrlParam } from 'configs/appConstants';

const useStylesLao = makeStyles((theme) => ({
  menuButtonLao: {
    marginRight: theme.spacing(1),
    padding: theme.spacing(1),
    '&:hover': {
      background: theme.palette.primary.pressed
    }
  },
  menuButtonFocusLao: {
    background: theme.palette.primary.pressed,
    borderRadius: theme.spacing(0.5),
    marginRight: theme.spacing(1),
    padding: theme.spacing(1)
  },
  appdrawerLao: {
    flexShrink: 0
  },
  paperLao: {
    width: 300,
    backgroundColor: theme.palette.background.drawer,
    borderRight: 'none',
    top: theme.spacing(8),
    boxShadow: `0px ${theme.spacing(1.5)}px ${theme.spacing(2.5)}px 0px rgba(0, 0, 0, 0.12)`,
    [theme.breakpoints.down("sm")]: {
      top: theme.spacing(7.25)
    }
  },
  drawerHeaderLao: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    // ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
    backgroundColor: theme.palette?.background?.primaryBase,
    color: theme.palette.white,
    minHeight: 50
  },
  drawerSpanLao: {
    display: 'inline-flex',
    cursor: 'pointer'
  },
  linkLao: {
    display: 'inline-flex',
    alignItems: 'center'
  },
  listItemsLao: {
    borderBottom: `1px solid ${theme.palette.text.primary}`
  },
  iconLao: {
    width: theme.spacing(3)
  },
  activeMenuLao:
  {
    backgroundColor: theme.palette?.background?.selected,
    borderBottom: `1px solid ${theme.palette.text.primary}`,
    "&:hover": {
      backgroundColor: theme.palette?.background?.selected,
    }
  }
}));

const LaoHamburger = () => {
  const classes = useStylesLao();
  const { t } = useTranslation();
  const [openDrawerLao, setDrawerOpenLao] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const pageUrlLao = location?.pathname.split('/')[4];
  const [activeLinkLao, setActiveLinkLao] = useState(() => pageUrlLao);

  const goToPageLao = (page) => {
    const parsed = qs.parse(location.search)
    let regx = new RegExp("[^\/]+$", "g");
    // let excludedUrlValue = location?.pathname.split('/')[5];
    // let path = excludedUrlParam.includes(excludedUrlValue) ? location?.pathname.replace(`/${excludedUrlValue}`, "") : location?.pathname;
    let pathLao = location?.pathname;
    let pathnameLao = pathLao.replace(regx, page);

    if (pathLao === pathnameLao) {
      return;
    }

    const tableType = {
      home: "exportOrderDetails",
      exportPlanning: "exportDRPDetails",
      // importKPI :  "importOrderDetails"
    }
    const chartType = {
      home: "export_daily",
      exportPlanning: "drp_daily_cases"
    }

    history.push({
      ...location,
      search: qs.stringify({
        ...parsed,
        chartType: chartType[page],
        tableType: tableType[page],
        documentDate: undefined,
        loadView: true,
        kpiType: undefined
      }),
      pathname: pathnameLao
    })
  }

  useEffect(() => {
    setActiveLinkLao(pageUrlLao);
  }, [pageUrlLao])

  return (
    <>
      <IconButton
        data-testid="menu-lao"
        aria-label="open drawer lao"
        onClick={() => setDrawerOpenLao(!openDrawerLao)}
        edge="start"
        className={openDrawerLao ? classes.menuButtonFocusLao : classes.menuButtonLao}>
        <img src={HamburgerIcon} alt="menu-lao" />
      </IconButton>

      <Drawer
        data-testid="app-drawer-lao"
        className={classes.appdrawerLao}
        variant="persistent"
        anchor="left"
        open={openDrawerLao}
        classes={{ paper: classes.paperLao }}
      >
        <div className={classes.drawerHeaderLao}>
          <span className={classes.drawerSpanLao} onClick={() => setDrawerOpenLao(!openDrawerLao)}>
            <Typography data-testid="closeMenu-lao" variant="body1" > {t("close_menu")} </Typography>
            <CloseIcon fontSize='small' />
          </span>
        </div>
        <List>

          <ListItem button key={'Home'} className={activeLinkLao == 'home' ? classes.activeMenuLao : classes.listItemsLao} onClick={() => goToPageLao("home")} data-testid='item-home'>
            <CTLink className={classes.linkLao} >
              <ListItemIcon> <img src={HomeIcon} alt="home-icon" className={classes.iconLao} /> </ListItemIcon>
              <ListItemText primary={t('home')} />
            </CTLink>
          </ListItem>
          <ListItem button key={'Export Planning'} className={activeLinkLao == 'exportPlanning' ? classes.activeMenuLao : classes.listItemsLao} onClick={() => goToPageLao("exportPlanning")} data-testid='item-exportPlanning'>
            <CTLink className={classes.linkLao} >
              <ListItemIcon> <img src={OrdersIcon} alt="export-planning-icon" className={classes.iconLao} /> </ListItemIcon>
              <ListItemText primary={t('export_planning')} />
            </CTLink>
          </ListItem>

          <ListItem button key={'kpi'} className={activeLinkLao == 'kpi' ? classes.activeMenuLao : classes.listItemsLao} onClick={() => goToPageLao("kpi")} data-testid='item-kpi'>
            <CTLink className={classes.linkLao} >
              <ListItemIcon> <BarChartIcon className={classes.iconLao} /> </ListItemIcon>
              <ListItemText primary={t('kpi')} />
            </CTLink>
          </ListItem>

        </List>
      </Drawer>
    </>
  )
}

export default LaoHamburger;